export const BASE_URL = import.meta.env.VITE_APP_BASE_URL;
export const AZURE_STORAGE_URL = import.meta.env.VITE_APP_AZURE_STORAGE_URL;
export const PUSHER_KEY = import.meta.env.VITE_APP_PUSHER_KEY;
export const ENV_MODE = import.meta.env.MODE;
export const SENTRY_DSN = import.meta.env.VITE_APP_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_APP_SENTRY_ENVIRONMENT;
